import React, { useState, useEffect } from 'react';
import { Filters } from 'layout';
import { Button, ButtonGroup, DateRangePicker } from '@kudi-inc/dip';
import cx from 'classname';
import moment from 'moment';
import styles from './products.module.scss';

const Filter = ({
  isDate,
  isStatus,
  isProductStatus,
  update,
  updateProductType,
  className,
  filters,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setfocusedInput] = useState(null);
  const [status, setStatus] = useState('');
  const [productStatus, setProductStatus] = useState(null);

  const onDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const onFocusChange = (focusedInput) => {
    setfocusedInput(focusedInput);
  };

  useEffect(() => {
    if (!startDate || !endDate) return;

    update(
      status
        ? {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD'),
            status,
          }
        : {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD'),
          }
    );
  }, [startDate, endDate, status, update]);

  useEffect(() => {
    updateProductType(productStatus);
  }, [productStatus, updateProductType]);

  useEffect(() => {
    if (!startDate && !endDate && filters?.startDate && filters?.endDate) {
      if (filters.startDate) setStartDate(moment(filters.startDate));
      if (filters.endDate) setEndDate(moment(filters.endDate));
    } else if (!Object.values(filters).length) {
      setStartDate(moment().subtract(1, 'months'));
      setEndDate(moment());
    }
  }, [filters, startDate, endDate]);

  return (
    <Filters className={cx(styles.filters, className)}>
      {isDate && (
        <DateRangePicker
          onDatesChange={onDatesChange}
          onFocusChange={onFocusChange}
          displayFormat="DD MMM, YY"
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          enableOutsideDays
          isOutsideRange={() => false}
        />
      )}
      {isStatus && (
        <ButtonGroup className={cx(styles.grpBtn, 'hideOnMobile')}>
          <Button active>All</Button>
          <Button
            value="active"
            options={[
              { value: 'PENDING_APPROVAL', text: 'Pending Approval' },
              { value: 'ACTIVE', text: 'Active' },
              { value: 'DISABLE', text: 'Disable' },
              { value: 'ARCHIVED', text: 'Archived' },
            ]}
            dropdown
            onSelect={setStatus}
          >
            Select
          </Button>
        </ButtonGroup>
      )}

      {/* {isProductStatus && (
        <ButtonGroup className={cx(styles.grpBtn, 'hideOnMobile')}>
          <Button
            active={
              (productStatus === '' || productStatus === null) && 'active'
            }
            onClick={() => setProductStatus(null)}
          >
            All
          </Button>
          <Button
            value="COLLECTIONS"
            active={
              productStatus === '' ||
              productStatus === null ||
              (productStatus === 'COLLECTIONS' && 'active')
            }
            onClick={() => setProductStatus('COLLECTIONS')}
          >
            Collections
          </Button>
          <Button
            value="Payout"
            active={productStatus === 'PAYOUT' && 'active'}
            onClick={() => setProductStatus('PAYOUT')}
          >
            Payout
          </Button>
          <Button
            value="REGISTRATIONS"
            active={productStatus === 'REGISTRATIONS' && 'active'}
            onClick={() => setProductStatus('REGISTRATIONS')}
          >
            Registrations
          </Button>
        </ButtonGroup>
      )}*/}
    </Filters>
  );
};

Filter.defaultProps = {
  isDate: true,
  isStatus: true,
  isProductStatus: true,
  update: () => null,
  updateProductType: () => null,
};

export default Filter;
